import { FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";

import { api } from "services";

import Forms from "../../../Forms";
import { Conditional, Grid, toast } from "../../../Utilities";

import { createModal } from "../../promised";
import Base from "../Base";

import { IAddressModalProps } from "./interfaces";

import { useDebounce } from "hooks/debounce";
import validationSchema from "./validations";

const Address: React.FC<IAddressModalProps> = (props) => {
  const [loading, setLoading] = useState(false);
  const [disabledFields, setDisabledFields] = useState([]);

  const onSubmit = (values) => {
    form.resetForm();
    props.onSubmit(values);
  };

  const form = useFormik({
    initialValues: {
      zipcode: props.zipcode || "",
      street: "",
      number: "",
      complement: "",
      neighborhood: "",
      city: "",
      state: "",
    },
    validationSchema,
    onSubmit,
  });

  const zipcode = useDebounce(form.values.zipcode);

  const onDismiss = () => {
    form.resetForm();
    props.onDismiss();
  };

  const fetchAddress = async () => {
    try {
      setLoading(true);

      const address = await api.addresses.getByZipcode(zipcode);

      Object.entries(address).map((entry) => {
        setDisabledFields((state) => [...state, !!entry[1] && entry[0]]);
      });

      form.setValues({
        zipcode,
        street: address.street,
        neighborhood: address.neighborhood,
        city: address.city,
        state: address.state,
        complement: "",
        number: "",
      });
    } catch (error) {
      toast("Por favor insira um CEP válido.", {
        type: "error",
      });

      props.onDismiss();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.initialValues) {
      form.setValues(props.initialValues);
    }
  }, []);

  useEffect(() => {
    if (zipcode && !form.errors?.zipcode && !props.initialValues)
      fetchAddress();
  }, [zipcode]);

  // useEffect(() => {
  //   !!props.zipcode && fetchAddress()
  // }, [])

  return (
    <Base
      icon="Map"
      title="Confirmação de endereço"
      description={`Por favor confirme abaixo o endereço completo<br />referente ao CEP ${props.zipcode} inserido anteriormente.`}
      onSubmit={{
        label: "Confirmar endereço",
        handler: () => form.handleSubmit(),
      }}
      onDismiss={{
        label: "Cancelar",
        handler: onDismiss,
      }}
      loading={{
        status: loading,
        message: "Aguarde, buscando endereço.",
      }}
    >
      <FormikProvider value={form}>
        <Conditional when={!props.zipcode}>
          <Grid columns="1fr 2fr" space="0 0 1rem">
            <Forms.InputGroup
              name="zipcode"
              label="CEP"
              placeholder="Digite o CEP"
              size="block"
              mask="zipcode"
            />
          </Grid>
        </Conditional>

        <Forms.InputGroup
          name="street"
          label="Rua"
          placeholder="Confirme a rua"
          size="block"
          readOnly={disabledFields.includes("street")}
        />

        <Grid columns="1fr 2fr" gap="1rem" space="1rem 0">
          <Forms.InputGroup
            name="number"
            label="Número"
            placeholder="Ex: 130"
          />

          <Forms.InputGroup
            name="complement"
            label="Complemento"
            placeholder="Ex.: Bloco 10; Apto 172"
          />
        </Grid>

        <Grid columns="1fr 1fr .5fr" gap="1rem">
          <Forms.InputGroup
            name="neighborhood"
            label="Bairro"
            placeholder="Confirme o bairro"
            readOnly={disabledFields.includes("neighborhood")}
          />

          <Forms.InputGroup
            name="city"
            label="Cidade"
            placeholder="Confirme a cidade"
            readOnly={disabledFields.includes("city")}
          />

          <Forms.InputGroup
            name="state"
            label="Estado"
            placeholder="Confirme o estado"
            readOnly={disabledFields.includes("state")}
          />
        </Grid>
      </FormikProvider>
    </Base>
  );
};

export default (props?: IAddressModalProps) => createModal(Address, props);
